<!--  -->
<template>
  <div class="activity">
    <!-- 导航栏 -->
    <van-nav-bar :title="type==0?'活动记录':'活动通知'" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back"  v-show="type==0"/>
      </template>
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <Item :list="list" :type="type" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getActivtyList, getApplication } from "@/api/apiData";
import Item from "./item";
import { Toast } from "vant";
export default {
  components: { Item },

  data() {
    return {
      type: "", //0 培训记录 undefined 活动列表
      page: 0, //当前页码
      totalPages: 1, //总页数
      offset: 5, //每页数据条数
      list: [],
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {},
  methods: {
    goBack() {
      if (this.type == 0) {
        this.$router.replace({
          name: "Profile"
        });
      } else {
        this.$router.back();
      }
    },
    // 上拉加载
    onLoad() {
      this.getList();
    },
    // 下拉刷新
    onRefresh() {},
    // 获取活动记录
    getActiveList() {
      var that = this;
      getApplication();
    },
    // 获取列表
    getList() {
      var that = this;
      var page = that.page + 1;
      var offset = that.offset;
      var totalPages = that.totalPages;
      var list = that.list;
      var type = that.type; //undefined 培训列表 0 培训记录
      var obj = {
        page: page,
        offset: offset
      };
      if (totalPages >= page) {
        if (type == 0) {
          // 获取培训记录列表
          getApplication(obj).then(res => {
            //(res);
            if (res.code == 1) {
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              that.list = list.concat(res.data.list);
              that.page = page;
              if (res.data.list.length == 0) {
                that.loading = false;
                that.finished = true;
                return false;
              }
              if (that.list.length > list.length) {
                setTimeout(() => {
                  that.loading = false;
                }, 1500);
              }
            } else {
              // Toast(res.msg);
              setTimeout(() => {
                that.$router.back();
              }, 2000);
            }
          });
        } else {
          // 获取培训列表
          getActivtyList(obj).then(res => {
            // //(res);
            if (res.code == 1) {
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              that.list = list.concat(res.data.list);
              that.page = page;
              if (res.data.list.length == 0) {
                that.loading = false;
                that.finished = true;
                return false;
              }
              if (that.list.length > list.length) {
                setTimeout(() => {
                  that.loading = false;
                }, 1500);
              }
            } else {
              // Toast(res.msg);
            }
          });
        }
      } else {
        that.finished = true;
        that.loading = false;
      }
    }
  },
  created() {
  
    this.type = this.$route.params.type;
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
.activity {
  padding: 0.2rem 0.32rem;
}
</style>